import { useApolloClient } from '@apollo/client';
import SiteSelection from 'FeatureModules/Site/Components/Forms/SiteSelection';
import { BASE_SITE_FRAGMENT } from 'graphql/secure/fragments/site.fragments';
import React, { FC, useState } from 'react';
import { IBaseSite } from 'FeatureModules/Site/types/site.types';
import { EFilterType, IFilterComponentProps } from './filter.types';

const SitesFilter: FC<IFilterComponentProps<EFilterType.SITES>> = ({ value, onChange }) => {
  const client = useApolloClient();

  const getDefaultSitesFromCache = () => {
    const values = value?.map(id =>
      client.readFragment<IBaseSite>({
        fragment: BASE_SITE_FRAGMENT,
        id: `Site:${id}-en`,
        fragmentName: 'baseSiteValues',
      })
    );
    return (values?.filter(Boolean) || undefined) as IBaseSite[] | undefined;
  };

  const [selectedSites, setSelectedSites] = useState<IBaseSite[] | undefined>(
    getDefaultSitesFromCache()
  );

  const handleSelectionChange = (selectedItem?: IBaseSite[]) => {
    setSelectedSites(selectedItem);
    onChange(selectedItem ? selectedItem.map(({ id }) => id) : undefined);
  };

  return (
    <SiteSelection
      label="Sites or clusters"
      placeholder="All sites or clusters"
      multiple
      addNewItem={false}
      size="small"
      defaultValue={selectedSites}
      onSelectionChange={handleSelectionChange}
    />
  );
};

export default SitesFilter;
